import { render, staticRenderFns } from "./veJkyReport.vue?vue&type=template&id=f912e96c&scoped=true"
import script from "./veJkyReport.vue?vue&type=script&lang=js"
export * from "./veJkyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f912e96c",
  null
  
)

export default component.exports